import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, forwardRef, inject } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { Events } from '@df/core/service/event';
import { AbService } from '@df/module-ab/ab.service';
import { IAddToBasketData } from '@df/session/api/basket/basket';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { Subscription } from 'rxjs/internal/Subscription';
import { StickyFreeComponent } from '../../../../../common/sticky-free/sticky-free.component';
import { BreadcrumbsComponent } from '../../../../../ui/common/breadcrumbs.component';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { ICmsOutletBlockComponent } from '../../../../outlet-block/icms-outlet-block.component';
import { AddToBasketComponent } from '../../../basket/add-to-basket';
import { ProductConfigurableOptionsComponent } from '../../configurable-options';
import { ProductConfigurableOptionsSizeComponent } from '../../configurable-options/size/product-configurable-options-size.component';
import { PageComponentCountdownBannerComponent } from '../../countdown-banner/countdown-banner.component';
import { ProductDeliveryMessagesComponent } from '../../delivery/messages/product-delivery-messages.component';
import { ProductGiftBoxComponent } from '../../gift/box/product-gift-box.component';
import { ProductBundleOptionsComponent } from '../../product-bundle-options.component';
import { IParentView } from '../layout/product-view-layout.abstract';
import { IProductViewLayoutContent } from '../layout/product-view-layout.interface';
import { ProductViewNameComponent } from '../name/product-view-name.component';
import { ProductViewShareComponent } from '../share/product-view-share.component';
import { ProductViewSummaryComponent } from '../summary/product-view-summary.component';

@Component({
    selector: 'product-view-details',
    templateUrl: './product-view-details.component.html',
    styleUrl: './product-view-details.component.scss',
    standalone: true,
    imports: [
        AddToBasketComponent,
        BreadcrumbsComponent,
        CommonModule,
        ICmsClientModule,
        ICmsOutletBlockComponent,
        ProductBundleOptionsComponent,
        forwardRef(() => ProductConfigurableOptionsComponent),
        forwardRef(() => ProductConfigurableOptionsSizeComponent),
        PageComponentCountdownBannerComponent,
        ProductDeliveryMessagesComponent,
        forwardRef(() => ProductGiftBoxComponent),
        ProductViewNameComponent,
        ProductViewShareComponent,
        ProductViewSummaryComponent,
        SizeClassDirective,
        StickyFreeComponent,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewDetailsComponent extends UiComponent implements OnInit {
    @Input({ required: true })
    product!: ProductDecorator<IProductDataV3>;

    @Input({ required: true })
    parentView!: IParentView;

    @Input()
    parent: ProductDecorator<IProductDataV3>;

    @Input()
    content: IProductViewLayoutContent;

    protected abServiceSubscription?: Subscription;

    sizeOptions = false;

    /**
     * Gift box
     */
    shouldAddGiftBoxProduct = false;

    protected abService = inject(AbService);
    protected events = inject(Events);

    override ngOnInit(): void {
        this.subscriptions.add(this.parentView.detectChanges$.subscribe(() => this.detectChanges()));

        super.ngOnInit();
    }

    giftBoxSelectionChangeHandle(value: boolean) {
        this.shouldAddGiftBoxProduct = value;

        this.detectChanges();
    }

    /**
     * Gift box product add to cart
     */
    getBasketRequest(): IAddToBasketData[] | undefined {
        if (this.shouldAddGiftBoxProduct) {
            return [
                // main product
                {
                    id: this.product.id,
                    qty: 1,
                    ...this.parentView.request
                },
                // gift box product
                {
                    id: this.product.data?.gift_box_product_id,
                    qty: 1
                }
            ];
        }

        return undefined;
    }

    openXnotifEmail(): void {
        this.events.broadcast('xnotif-open');
    }
}
